module.exports = __webpack_public_path__ + "static/media/8.38611686.jpg";